export { default as YarnDyed } from './YarnDyed/YarnDyed';
export { default as SolidGreige } from './SolidGreige/SolidGreige';
export { default as Embroidery } from './Embroidery/Embroidery';
export { default as Print } from './Print/Print';
export { default as FabricMainSection } from './FabricMainSection/FabricMainSection';




// WEBPACK FOOTER //
// ./src/components/Fabric/index.js